import {
  ImportedItemRow,
  ImportedItemValidationResult,
  ImportedItemValidator,
  ImportFormatItem,
} from './importTypes';

/**
 * Checks if the number of columns in the row matches the expected number of columns based on the import format.
 * @param importFormat format that defines the expected number of columns
 */
export const createValidColumnsCountValidator = <T>(
  importFormat: readonly ImportFormatItem<T>[],
): ImportedItemValidator<T> => {
  const columnsCount = importFormat.length;

  return (item: ImportedItemRow<T>): ImportedItemValidationResult => {
    if (item.rawData.length > columnsCount) {
      return [`Invalid number of columns (expected ${columnsCount}, got ${item.rawData.length})`];
    }
  };
};
